/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.2 Human.glb -k --bones 
*/

import React, { useEffect, useState } from 'react'
import { useGraph } from '@react-three/fiber'
import { useGLTF } from '@react-three/drei'
import { SkeletonUtils } from 'three-stdlib'

export function Human({activity, isCrashed, ...props}) {
  const group = React.useRef()
  const { scene } = useGLTF('/Human.glb')
  const clone = React.useMemo(() => SkeletonUtils.clone(scene), [scene])
  const { nodes, materials } = useGraph(clone)

  const greyColor = 0x343a40
  const redColor = 0xFF0000
  const [humanColor, setHumanColor] = useState(null)

  useEffect(() => {
    if (!isCrashed){
      
      setHumanColor(greyColor);
    }
    else {
      if (activity === "unconscious") {
        setHumanColor(redColor);
      }
      else {
        setHumanColor(greyColor);
      }
    }
  }, [isCrashed, activity]);

  
  return (
<group ref={group} object={clone} {...props} dispose={null}>
      <group name="Scene">
        <group name="Armature" position={[0,0.3,0]} rotation={[0, 0, 0]} scale={0.0075}>
          <primitive object={nodes.mixamorigHips} name="mixamorigHips" position={[0, 1.554, -104.275]} rotation={[-1.558, 0, 0]}>
            <primitive object={nodes.mixamorigSpine} name="mixamorigSpine" position={[0, 10.182, 0]} rotation={[Math.PI / 2, 0, 0]}>
              <primitive object={nodes.mixamorigSpine1} name="mixamorigSpine1" position={[0, 10.003, 0]}>
                <primitive object={nodes.mixamorigSpine2} name="mixamorigSpine2" position={[0, 9.322, 0]} rotation={[0.026, 0, 0]}>
                  <primitive object={nodes.mixamorigNeck} name="mixamorigNeck" position={[0, 16.865, 0]}>
                    <primitive object={nodes.mixamorigHead} name="mixamorigHead" position={[0, 9.342, 2.841]}>
                      <primitive object={nodes.mixamorigHeadTop_End} name="mixamorigHeadTop_End" position={[0, 20.963, 10.123]} />
                    </primitive>
                  </primitive>
                  <primitive object={nodes.mixamorigRightShoulder} name="mixamorigRightShoulder" position={[-4.57, 11.196, -0.807]} rotation={[1.69, 0.05, 1.778]}>
                    <primitive object={nodes.mixamorigRightArm} name="mixamorigRightArm" position={[0, 10.838, 0]} rotation={[Math.PI / 2, 0.01, -0.207]}> {/* Epaule*/ }
                      <primitive object={nodes.mixamorigRightForeArm} name="mixamorigRightForeArm" position={[0, 27.842, 0]} rotation={[0, 0, -Math.PI / 2]}>
                        <primitive object={nodes.mixamorigRightHand} name="mixamorigRightHand" position={[0, 28.329, 0]}>
                          <primitive object={nodes.mixamorigRightHandThumb1} name="mixamorigRightHandThumb1" position={[2.682, 2.465, 1.574]} rotation={[0.527, 0, -0.477]}>
                            <primitive object={nodes.mixamorigRightHandThumb2} name="mixamorigRightHandThumb2" position={[0, 4.189, 0]} rotation={[-0.005, -0.002, 0.019]}>
                              <primitive object={nodes.mixamorigRightHandThumb3} name="mixamorigRightHandThumb3" position={[0, 3.416, 0]} rotation={[-0.003, -0.002, 0.014]}>
                                <primitive object={nodes.mixamorigRightHandThumb4} name="mixamorigRightHandThumb4" position={[0, 2.575, 0]} rotation={[0, -0.236, -0.098]} />
                              </primitive>
                            </primitive>
                          </primitive>
                          <primitive object={nodes.mixamorigRightHandIndex1} name="mixamorigRightHandIndex1" position={[2.26, 9.108, 0.518]}>
                            <primitive object={nodes.mixamorigRightHandIndex2} name="mixamorigRightHandIndex2" position={[0, 3.7, 0]} rotation={[0, 0, 0.001]}>
                              <primitive object={nodes.mixamorigRightHandIndex3} name="mixamorigRightHandIndex3" position={[0, 2.85, 0]}>
                                <primitive object={nodes.mixamorigRightHandIndex4} name="mixamorigRightHandIndex4" position={[0, 2.772, 0]} rotation={[0, 0.002, 0]} />
                              </primitive>
                            </primitive>
                          </primitive>
                          <primitive object={nodes.mixamorigRightHandMiddle1} name="mixamorigRightHandMiddle1" position={[0, 9.533, 0]} rotation={[0, 0, -0.001]}>
                            <primitive object={nodes.mixamorigRightHandMiddle2} name="mixamorigRightHandMiddle2" position={[0, 3.7, 0]} rotation={[0, 0, 0.002]}>
                              <primitive object={nodes.mixamorigRightHandMiddle3} name="mixamorigRightHandMiddle3" position={[0, 2.95, 0]} rotation={[0, 0, -0.001]}>
                                <primitive object={nodes.mixamorigRightHandMiddle4} name="mixamorigRightHandMiddle4" position={[0, 2.947, 0]} rotation={[0, 0.002, 0]} />
                              </primitive>
                            </primitive>
                          </primitive>
                          <primitive object={nodes.mixamorigRightHandRing1} name="mixamorigRightHandRing1" position={[-1.865, 9.104, 0.043]}>
                            <primitive object={nodes.mixamorigRightHandRing2} name="mixamorigRightHandRing2" position={[0, 3.379, 0]}>
                              <primitive object={nodes.mixamorigRightHandRing3} name="mixamorigRightHandRing3" position={[0, 2.89, 0]}>
                                <primitive object={nodes.mixamorigRightHandRing4} name="mixamorigRightHandRing4" position={[0, 2.639, 0]} rotation={[0, 0, -0.002]} />
                              </primitive>
                            </primitive>
                          </primitive>
                          <primitive object={nodes.mixamorigRightHandPinky1} name="mixamorigRightHandPinky1" position={[-3.806, 8.077, 0.487]} rotation={[0, 0, 0.001]}>
                            <primitive object={nodes.mixamorigRightHandPinky2} name="mixamorigRightHandPinky2" position={[0, 3.6, 0]} rotation={[0, 0, 0.002]}>
                              <primitive object={nodes.mixamorigRightHandPinky3} name="mixamorigRightHandPinky3" position={[0, 2.1, 0]} rotation={[0, 0, -0.001]}>
                                <primitive object={nodes.mixamorigRightHandPinky4} name="mixamorigRightHandPinky4" position={[0, 2.116, 0]} rotation={[0, 0.003, 0]} />
                              </primitive>
                            </primitive>
                          </primitive>
                        </primitive>
                      </primitive>
                    </primitive>
                  </primitive>
                  <primitive object={nodes.mixamorigLeftShoulder} name="mixamorigLeftShoulder" position={[4.57, 11.196, -0.807]} rotation={[1.693, -0.049, -1.778]}>
                    <primitive object={nodes.mixamorigLeftArm} name="mixamorigLeftArm" position={[0, 10.838, 0]} rotation={[Math.PI / 2, -0.01, 0.207]}> {/* Left SHOULDER*/}
                      <primitive object={nodes.mixamorigLeftForeArm} name="mixamorigLeftForeArm" position={[0, 27.842, 0]} rotation={[0, 0, Math.PI / 2]}> {/* Left arm*/}
                        <primitive object={nodes.mixamorigLeftHand} name="mixamorigLeftHand" position={[0, 28.329, 0]}>
                          <primitive object={nodes.mixamorigLeftHandThumb1} name="mixamorigLeftHandThumb1" position={[-2.682, 2.466, 1.576]} rotation={[0.527, 0, 0.475]}>
                            <primitive object={nodes.mixamorigLeftHandThumb2} name="mixamorigLeftHandThumb2" position={[0, 4.187, 0]} rotation={[-0.004, 0.002, -0.016]}>
                              <primitive object={nodes.mixamorigLeftHandThumb3} name="mixamorigLeftHandThumb3" position={[0, 3.418, 0]} rotation={[-0.003, 0.002, -0.012]}>
                                <primitive object={nodes.mixamorigLeftHandThumb4} name="mixamorigLeftHandThumb4" position={[0, 2.581, 0]} rotation={[0, 0.246, 0.084]} />
                              </primitive>
                            </primitive>
                          </primitive>
                          <primitive object={nodes.mixamorigLeftHandIndex1} name="mixamorigLeftHandIndex1" position={[-2.26, 9.109, 0.518]}>
                            <primitive object={nodes.mixamorigLeftHandIndex2} name="mixamorigLeftHandIndex2" position={[0, 3.7, 0]}>
                              <primitive object={nodes.mixamorigLeftHandIndex3} name="mixamorigLeftHandIndex3" position={[0, 2.85, 0]}>
                                <primitive object={nodes.mixamorigLeftHandIndex4} name="mixamorigLeftHandIndex4" position={[0, 2.775, 0]} rotation={[0, -0.001, 0]} />
                              </primitive>
                            </primitive>
                          </primitive>
                          <primitive object={nodes.mixamorigLeftHandMiddle1} name="mixamorigLeftHandMiddle1" position={[0, 9.533, 0]}>
                            <primitive object={nodes.mixamorigLeftHandMiddle2} name="mixamorigLeftHandMiddle2" position={[0, 3.7, 0]}>
                              <primitive object={nodes.mixamorigLeftHandMiddle3} name="mixamorigLeftHandMiddle3" position={[0, 2.95, 0]}>
                                <primitive object={nodes.mixamorigLeftHandMiddle4} name="mixamorigLeftHandMiddle4" position={[0, 2.953, 0]} rotation={[0, -0.002, 0]} />
                              </primitive>
                            </primitive>
                          </primitive>
                          <primitive object={nodes.mixamorigLeftHandRing1} name="mixamorigLeftHandRing1" position={[1.865, 9.105, 0.043]}>
                            <primitive object={nodes.mixamorigLeftHandRing2} name="mixamorigLeftHandRing2" position={[0, 3.15, 0]}>
                              <primitive object={nodes.mixamorigLeftHandRing3} name="mixamorigLeftHandRing3" position={[0, 2.95, 0]}>
                                <primitive object={nodes.mixamorigLeftHandRing4} name="mixamorigLeftHandRing4" position={[0, 2.644, 0]} rotation={[0, 0.001, 0]} />
                              </primitive>
                            </primitive>
                          </primitive>
                          <primitive object={nodes.mixamorigLeftHandPinky1} name="mixamorigLeftHandPinky1" position={[3.806, 8.078, 0.487]} rotation={[0, 0, 0.004]}>
                            <primitive object={nodes.mixamorigLeftHandPinky2} name="mixamorigLeftHandPinky2" position={[0, 3.6, 0]}>
                              <primitive object={nodes.mixamorigLeftHandPinky3} name="mixamorigLeftHandPinky3" position={[0, 2.1, 0]}>
                                <primitive object={nodes.mixamorigLeftHandPinky4} name="mixamorigLeftHandPinky4" position={[0, 2.126, 0]} rotation={[0, -0.002, -0.001]} />
                              </primitive>
                            </primitive>
                          </primitive>
                        </primitive>
                      </primitive>
                    </primitive>
                  </primitive>
                </primitive>
              </primitive>
            </primitive>
            <primitive object={nodes.mixamorigRightUpLeg} name="mixamorigRightUpLeg" position={[-8.208, -6.772, -1.512]} rotation={[-0.021, 0, Math.PI]}>
              <primitive object={nodes.mixamorigRightLeg} name="mixamorigRightLeg" position={[0, 44.371, 0]} rotation={[-Math.PI / 2, 0, 0]}>
                <primitive object={nodes.mixamorigRightFoot} name="mixamorigRightFoot" position={[0, 44.528, 0]} rotation={[0.955, 0, 0]}>
                  <primitive object={nodes.mixamorigRightToeBase} name="mixamorigRightToeBase" position={[0, 13.817, 0]} rotation={[0.684, 0, 0]}>
                    <primitive object={nodes.mixamorigRightToe_End} name="mixamorigRightToe_End" position={[0, 9.278, 0]} rotation={[0, 0.023, 0]} />
                  </primitive>
                </primitive>
              </primitive>
            </primitive>
            <primitive object={nodes.mixamorigLeftUpLeg} name="mixamorigLeftUpLeg" position={[8.208, -6.772, -1.512]} rotation={[-0.021, 0, Math.PI]}>
              <primitive object={nodes.mixamorigLeftLeg} name="mixamorigLeftLeg" position={[0, 44.371, 0]} rotation={[-Math.PI / 2, 0, 0]}>
                <primitive object={nodes.mixamorigLeftFoot} name="mixamorigLeftFoot" position={[0, 44.528, 0]} rotation={[0.955, 0, 0]}>
                  <primitive object={nodes.mixamorigLeftToeBase} name="mixamorigLeftToeBase" position={[0, 13.817, 0]} rotation={[0.684, 0, 0]}>
                    <primitive object={nodes.mixamorigLeftToe_End} name="mixamorigLeftToe_End" position={[0, 9.278, 0]} rotation={[0, -0.024, 0]} />
                  </primitive>
                </primitive>
              </primitive>
            </primitive>
          </primitive>
          <skinnedMesh name="Beta_Joints" geometry={nodes.Beta_Joints.geometry} material={materials.Beta_Joints_MAT1.clone()} skeleton={nodes.Beta_Joints.skeleton} material-color={humanColor} />
          <skinnedMesh name="Beta_Surface" geometry={nodes.Beta_Surface.geometry} material={materials.Beta_HighLimbsGeoSG3.clone()} skeleton={nodes.Beta_Surface.skeleton} material-color={humanColor}  />
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/Human.glb')
